<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="spinner-border spinner-border-lg loader" v-if="loading"></div>
                <div v-else>
                    <div class="card kx-card table-responsive">
                        <div class="row">
                            <div class="col-sm-6"></div>

                        </div>

                        <table v-if="!editingMode" class="table align-middle table-bordered text-center mt-3">
                            <thead>
                                <tr style="font-size: 13px;">
                                    <th>Scheduled On</th>
                                    <th>Done On</th>
                                    <th>Done By</th>
                                    <th>Follow-up Date</th>
                                    <th>Patient is Ideal For</th>
                                    <th>Patient is Willing For</th>
                                    <th>Remarks</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item in VideoConsultationData" :key="item.id" style="font-size: 12px;">
                                    <!-- Scheduled On -->

                                    <td>{{ formatDateTime(item.scheduled_on) }}</td>

                                    <!-- Done On -->

                                    <td>{{ formatDateTime(item.done_on) }}</td>

                                    <!-- Done By -->

                                    <td>{{ item.done_by }}</td>



                                    <!-- Follow-up Date -->

                                    <td>
                                        {{ formatDateTime(item.follow_up_date) }}
                                    </td>

                                    <!-- Ideal For -->

                                    <td>{{ item.ideal_for }}</td>

                                    <!-- Willing For (multi-select) -->

                                    <td>
                                        <span v-for="(option, idx) in item.willing_for" :key="idx"
                                            class="badge bg-info text-dark me-1">
                                            {{ typeof option === 'object' ? option.willingness : option }}
                                        </span>
                                    </td>




                                    <!-- Remarks -->

                                    <td>{{ item.video_consultation_remarks }}</td>

                                    <!-- Actions -->
                                    <td>
                                        <button class="btn btn-sm btn-info" @click="openEditRow(item)">Edit</button>


                                    </td>
                                </tr>
                            </tbody>

                        </table>
                        <div v-else class="card p-4">
                            <h5>Edit Video Consultation</h5>
                            <div class="row">
                                <!-- Scheduled On -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label text-danger">Video Consultation Scheduled on</label>
                                    <VueDatePicker v-model="selectedItem.editedScheduledOn" format="yyyy-MM-dd HH:mm" />
                                </div>

                                <!-- Done On -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label text-danger">Video Consultation Done on</label>
                                    <VueDatePicker v-model="selectedItem.editedDoneOn" format="yyyy-MM-dd HH:mm" />
                                </div>

                                <!-- Done By -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label text-danger">Video Consultation Done by</label>
                                    <select class="form-select" v-model="selectedItem.editedDoneBy">
                                        <option v-for="user in options" :key="user" :value="user">{{ user }}</option>
                                    </select>
                                </div>

                                <!-- Follow-up Date -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label text-danger">Video Consultation Follow up date</label>
                                    <VueDatePicker v-model="selectedItem.follow_up_date" format="yyyy-MM-dd" />
                                </div>

                                <!-- Ideal For -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Patient is Ideal for</label>
                                    <select class="form-select" v-model="selectedItem.editedIdealFor">
                                        <option v-for="option in idealForOptions" :key="option" :value="option">{{
                                            option }}</option>
                                    </select>
                                </div>

                                <!-- Willing For -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Patient is willing for</label>
                                    <div class="d-flex align-items-start flex-wrap gap-1">
                                        <select class="form-select" v-model="tempWillingFor"
                                            @change="handleWillingForSelect">
                                            <option disabled value="">Select an option</option>
                                            <option v-for="option in willingForOptions" :key="option" :value="option">{{
                                                option }}</option>
                                        </select>
                                        <div class="mt-2 d-flex flex-wrap gap-1">
                                            <span v-for="(item, index) in selectedItem.editedWillingFor" :key="index"
                                                class="badge bg-success text-white">
                                                {{ item }}
                                                <span class="ms-1" style="cursor:pointer;"
                                                    @click="removeWillingFor(index)">×</span>
                                            </span>

                                        </div>
                                    </div>
                                </div>


                                <!-- Remarks -->
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Video Consultation Remarks</label>
                                    <textarea class="form-control" v-model="selectedItem.editedRemarks"
                                        rows="3"></textarea>
                                </div>
                            </div>

                            <div class="text-end">
                                <button class="btn btn-primary me-2" @click="saveFromModal(selectedItem)">Save</button>
                                <button class="btn btn-secondary" @click="cancelEdit">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>





</template>

<script>
import axios from "axios";
import 'vue3-timepicker/dist/VueTimepicker.css';
import VueTimepicker from 'vue3-timepicker';


export default {
    name: "VideoConsultation",
    props: {
        msg: String,
    },
    data() {
        return {
            editingMode: false,
            selectedItem: null,
            idealForOptions: [],
            willingForOptions: [],
            options: [],
            VideoConsultationData: [],
            tempWillingFor: ""

        };
    },
    components: {
        VueTimepicker,
    },
    computed: {
        isFormValid() {
            return this.AddData.date !== "" && this.AddData.time !== "";
        },
    },

    mounted() {
        this.getVideoConsultationData();
        this.get_user_list_by_role();
        this.getIdealForOptions();
        this.getWillingForOptions();
    },
    methods: {


        async openEditRow(item) {
            console.log("Edit button clicked for", item.id);

            try {
                const response = await axios.post("knee_lead.api.get_single_video_consultation", {
                    name: item.id
                });

                const data = response.data.data;

                this.selectedItem = {
                    id: item.id,
                    editedScheduledOn: data.vc_scheduled_on || '',
                    editedDoneOn: data.vc_done_on || '',
                    editedDoneBy: data.video_consultation_done_by || '',
                    follow_up_date: data.vc_follow_up_date || '',
                    editedIdealFor: data.patient_is_ideal_for || '',
                    editedWillingFor: (data.patient_is_willing_for || []).map(entry =>
                        typeof entry === 'object' ? entry.willingness : entry
                    ),
                    editedRemarks: data.video_consultation_remarks || '',
                    lead_transfered_by: data.lead_transfered_by || ''
                };

                this.editingMode = true;

            } catch (error) {
                console.error("API error in openEditRow:", error);
                this.$toast?.error("Failed to fetch consultation details for editing.");
            }
        },

        handleWillingForSelect() {
            const val = this.tempWillingFor;
            if (val && !this.selectedItem.editedWillingFor.includes(val)) {
                this.selectedItem.editedWillingFor.push(val);
            }
            this.tempWillingFor = "";
        },
        removeWillingFor(index) {
            this.selectedItem.editedWillingFor.splice(index, 1);
        },

        async saveFromModal() {
            try {
                const payload = {
                    name: this.selectedItem.id,
                    knee_lead: this.$route.params.id,
                    vc_scheduled_on: this.formatToDateTimeLocal(this.selectedItem.editedScheduledOn),
                    vc_done_on: this.formatToDateTimeLocal(this.selectedItem.editedDoneOn),
                    video_consultation_done_by: this.selectedItem.editedDoneBy,
                    lead_transfered_by: this.selectedItem.lead_transfered_by || '',
                    patient_is_ideal_for: this.selectedItem.editedIdealFor,
                    patient_is_willing_for: this.selectedItem.editedWillingFor,
                    video_consultation_remarks: this.selectedItem.editedRemarks
                };

                const res = await axios.post("knee_lead.api.update_video_consultation", payload);

                if (res.data.status_code === 200) {
                    this.editingMode = false;
                    this.selectedItem = null;
                    window.location.reload();
                } else {
                    console(res.data.message || "Update failed. Please try again.");
                }

                this.getVideoConsultationData();
            } catch (error) {
                console.error("Error saving:", error);
            }
        },

        async getIdealForOptions() {
            try {
                const response = await axios.get("knee_lead.api.get_ideal_for");
                this.idealForOptions = response.data.data.filter(opt => opt !== ""); // remove empty
            } catch (error) {
                console.error("Failed to fetch 'ideal for' options:", error);
            }
        },

        async getWillingForOptions() {
            try {
                const response = await axios.get("knee_lead.api.get_willingness");
                this.willingForOptions = response.data.data.map(item => item.patient_is_willing_for);
            } catch (error) {
                console.error("Failed to fetch 'willing for' options:", error);
            }
        },
        get_user_list_by_role: async function (e) {
            await axios
                .get("knee_lead.docshare.get_users_by_role?role=Physiotherapist")
                .then((response) => {
                    this.options = [];
                    for (let x in response.data.data) {
                        this.options = response.data.data.map(user => user.users);
                    }
                })
                .catch((error) => { });
        },

        formatDateTime(dateString) {
            if (!dateString || isNaN(Date.parse(dateString))) return '-';
            const date = new Date(dateString);
            const formattedDate = date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            const formattedTime = date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
            return `${formattedDate.replace(/\//g, '-')} ${formattedTime}`;
        },

        async getVideoConsultationData() {
            this.loading = true;
            try {
                const response = await axios.get("knee_lead.api.get_all_video_consultations",
                    {
                        params: {
                            knee_lead: this.$route.params.id || ""
                        }
                    }
                )
                const records = response.data.data;

                // Map and format for rendering
                this.VideoConsultationData = response.data.data.map(item => ({
                    id: item.name,
                    scheduled_on: item.vc_scheduled_on || '',
                    done_on: item.vc_done_on || '',
                    done_by: item.video_consultation_done_by || '',
                    follow_up_date: item.vc_scheduled_on || '',
                    ideal_for: item.patient_is_ideal_for || '',
                    willing_for: item.patient_is_willing_for || [],
                    video_consultation_remarks: item.video_consultation_remarks || '',
                    editable: false,

                    // Editable fields
                    editedScheduledOn: item.vc_scheduled_on || '',
                    editedDoneOn: item.vc_done_on || '',
                    editedDoneBy: item.video_consultation_done_by || '',
                    editedIdealFor: item.patient_is_ideal_for || '',
                    editedWillingFor: [...(item.patient_is_willing_for || [])],
                    editedRemarks: item.video_consultation_remarks || ''
                }));



            } catch (error) {
                console.error("Error fetching video consultation data:", error);
            } finally {
                this.loading = false;
            }
        },
        formatToDateTimeLocal(dateObj) {
            if (!dateObj) return '';
            const pad = n => n < 10 ? '0' + n : n;
            const d = new Date(dateObj);
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },


    },

};
</script>

<style scoped>
::v-deep(.custom-datepicker input) {
    font-size: 12px !important;
}

.modal {
    position: fixed;
    top: 0;
    padding-top: 10px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 60%;
    width: 100%;
    position: relative;
}

.modal-content2 {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 50%;
    width: 100%;
    position: relative;
}

.close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
}

.close:hover {
    color: red;
}

::v-deep(.dp__menu) {
    z-index: 9999 !important;
    position: absolute !important;
}


.model-loading {
    position: fixed;
    top: 0;
    padding-top: 10px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.time-field {
    width: 100%;
}

.table-responsive {
    overflow: visible !important;
}

.kx-card {
    overflow: visible !important;
}

td {
    position: relative !important;
    overflow: visible !important;
}



.modal-loading-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 80%;
    width: 100%;
    position: relative;
}
</style>